<template>
  <div class="product-card-208-price-manager row ">
     <span class="col-6 p-0">
      <div class="d-flex">
        <span class="price-card-title">
         <div class="" v-if="isVariationProduct">
         {{ productFeatureName(product, feature.id) }}
        </div>

          <!--          delete price before offer -->
       <div class="mt-1 ">
         <span class="price-card-description">
           <span v-if="!isVariationProduct" :class="{ 'deleted': offer}"
                 v-html="$t('price.price', {currency:formatNumber(product.price)})">
           </span>
            <span v-else :class="{ 'deleted': offer}"
                  v-html="$t('price.price', {currency:formatNumber(feature.price)})">
           </span>
         </span>

         <!--         show offer-->
         <div class="price-card-description d-block">
           <span class="" v-if="isVariationProduct" v-html="showOffer(feature.id)">
           </span>
           <span v-else v-html="showOffer()">
           </span>
         </div>

       </div>
        </span>
      </div>
     </span>

    <!--    show price product-->
    <div class="col-6 text-left p-0 show-price-wrapper">
      <template v-if="isProductActive(product)">
        <ProductCardPrice200 v-if="isVariationProduct" class="m-auto product-single" :product="product"
                             :feature="feature"/>
        <NormalProduct v-if="!isVariationProduct" :show-trash-only-in-first-quantity="showTrashOnlyInFirstQuantity"
                       class="product-single" :product="product"/>
      </template>
      <template v-else>
        <div class="text-right" dir="rtl">
          <p v-t="`product.timing`"></p>
        </div>
      </template>
    </div>
  </div>
</template>
<script>

import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import mA from '../../../Tags/A.vue'
import mImg from '../../../Tags/Img.vue'
import Button from "../../../Tags/Button.vue";
import {OfferProps} from "../../../Product/ProductOffer/ProductOfferProps";
import ProductCardQuantityManager1 from "../../QuantityManager/Card/ProductCardQuantityManager1.vue";
import VariationProduct from "../../../Product/SingleProductPrice3/VariationProduct.vue";
import {productFeatureName} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import mShoppingCartQuantityManager1 from "../../ShoppingCartQuantityManager1.vue";
import ProductCardPrice200 from "../../../Product/ProductCardPrice200/ProductCardPrice200.vue";
import SingleProductPrice3 from "../../../Product/SingleProductPrice3/SingleProductPrice3.vue";
import NormalProduct from "../../../Product/SingleProductPrice3/NormalProduct.vue";
import {
  calculatePriceAndOffer,
  shoppingCartFunctions
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "ProductCard208PriceManager",
  props: {
    product: {},
    feature: {
      default: null
    },
    showTrashOnlyInFirstQuantity: {
      default: false,
    },
    ...OfferProps,
  },
  data() {
    return {
      price: '',
      offer: '',
      result: ''
    }
  },
  components: {
    NormalProduct,
    SingleProductPrice3,
    ProductCardPrice200,
    mShoppingCartQuantityManager1,
    VariationProduct,
    ProductCardQuantityManager1,
    Button,
    mA,
    mImg,
  },
  computed: {
    isVariationProduct() {
      return this.product.variation == 1
    }
  },
  methods: {
    ...shoppingCartFunctions,
    formatNumber, productFeatureName, calculatePriceAndOffer,
    showOffer(mode) {
      // This method check product has offer or no
      let localResult
      localResult = calculatePriceAndOffer(this.product, mode)

      if (localResult['offer'] !== null && localResult['offer'] !== 0) {
        this.offer = parseInt(localResult['offer'])
        this.price = parseInt(localResult['price'])
        this.result = this.price - this.offer
        return this.$t('price.price', {currency: formatNumber(this.result)})
      } else {
        return null
      }

    },
    setFeatureImage(feature) {

      let image = feature.image

      if (image == null) {
        return 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAZABkAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/wgALCADIAN8BAREA/8QAGwABAAMBAQEBAAAAAAAAAAAAAAUGBwMBBAL/2gAIAQEAAAAA24AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAi/i8Ak/vAABXbEOf57eQFgAABXbE59M+idX8gLAAACu2Ks5bsEpxjZuAsAAAK7zyHn9mw55Wtd7WAAAFOy3ke+Ouv2QAAEPXgFpkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD//EADoQAAEDAQMGCwgCAwEAAAAAAAECAwQFAAYREiEwMUDREBMWF1FUVmGRkrIHFCI1NkFzdCCBFTJScf/aAAgBAQABPwDazth2w7YdsO2HbDth2w6Ks1lNHRHxivSFyHOLQhrDEnDH725SzOzlT8qd9uUs3s5U/KnfblLN7OVPyp325SzezlT8qd9uUs3s5U/KnfblLN7OVPyp325SzezlT8qd9uUszs5U/Knfaj1RFYpyJjbS2kqUpOQvWCDhoTory/MqB+8PSf4vPNR2i684httOtSzgBaNMjTG+MjPtvIGbFtQI4DqNrl/TqPzO+s6E6K8vzKgfvD0nhS+yp9bCXUF1ABUgHOAdWI4PaeZXFQcnK90+LKw1Zf2x/q3s4965Qr4rK934o8d0d3948B1G1y/p1H5nfWdCdFeX5lQP3h6TwXsvY1QY5YYKXJ6x8KdYQOk7rRK3Ph1b/JNyFGSVYrUo45fSD3Wu9eGLeCCHmiEPJzOtE50ndZ5hqS0Wn20ONq1pWMQbNswaVFWptpmKwgZSylISB3m1EvVTq7Jfjx1FLjZOSlebjE/9Cx1G1y/p1H5nfWdCdFeX5lQP3h6Ta9l7GaFHLDBS5PWPhT9kDpO60iQ9KkLffcU46s4qUo5yeCmVOVSZyJcRwocSdX2UOg91qJeeDWKYqXxiWVNJxfQo/wCnf/5a917nK48YsVSkQEHMNRcPSe7utHkPRJCH2HFNuoOKVJOcG11b1tV6NxLxS3ObT8SPssdI3WuX9OI/M76zoTovaBMdp8Wmy2cONaklScRmxyTaRIelyFvvuKcdWcVKUcST/ALUkKCVEBQwIB1jhjyHYj6H2HFNuoOKVJOBBtcRZXdSOtWdSnHCfMdCdFeG77F4YrTD7zjQbXlgoAz5sPvbmxp/X5Pgm3NjT+vyfBNubGn9fk+Cbc2NP6/J8E25saf1+T4JtzY0/r8nwTbmxp/X5Pgm3NjT+vyfBNqLSm6LTG4LTinEIJIUrXnOOhO2HbDth2w7YdsO2HbDtht//9k='
      }

      return image

    }
  },
}
</script>

<style scoped>
.deleted {
  text-decoration: line-through;
}

.product-single :deep(h2) {
  display: none;
}

.product-single :deep(h3) {
  display: none;
}

.product-single :deep(normal-product-offer) {
  display: none;
}


.card-title h4 {
  font-weight: 700;
  font-size: .99rem !important;
  line-height: 1.5rem;
  width: auto;
  height: auto;
  display: inline-block;
  text-align: initial;
}

.card-title p {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  width: auto;
  height: auto;
  display: inline-block;
  text-align: initial;
}

.card-208-content-img {
  height: 63px;
  object-fit: contain;
  width: 53px;
}

.price-card-title {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  width: auto;
  height: auto;
  display: inline-block;
  color: rgb(58, 61, 66);
  text-align: initial;

}

.price-card-description {
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25rem;
  width: auto;
  height: auto;
  display: inline-block;
  color: rgb(58, 61, 66);
  text-align: initial;
}

</style>